import { gql } from 'apollo-angular';

export const NOTIFICATIONS_DETAILS_QUERY = gql`
  query Notifications {
    notifications {
      isSuccess
      message
      data {
        totalItems
        items {
          infoId
          notificationCategory
          subject
          message
          readStatus
          createdTime
          accountId
          serviceIds
          siteIds
          entityType
          entityId
          certificateNumber
          snowLink
        }
      }
    }
  }
`;
